import { Size } from '../../primitives/size';
import { DiagramElement } from './diagram-element';
import { measureNativeContent, getContent, measureNativeSvg } from './../../utility/dom-util';
/**
 * NativeElement defines the basic native elements
 */
export class DiagramNativeElement extends DiagramElement {
    /**
     *  set the id for each element \
     *
     * @returns { void } set the id for each element.\
     * @param {string} nodeId - provide the id value.
     * @param {string} diagramId - provide the id value.
     *
     * @private
     */
    constructor(nodeId, diagramId) {
        super();
        this.data = '';
        /**
         * set the node id
         */
        this.nodeId = '';
        /**
         * set the diagram id
         */
        this.diagramId = '';
        /**
         * sets scaling factor of the Native Element
         */
        this.scale = 'Stretch';
        this.diagramId = diagramId;
        this.nodeId = nodeId;
    }
    /**
     *  get the id for each element \
     *
     * @returns { string | SVGElement } get the id for each element.\
     *
     * @private
     */
    get content() {
        return this.data;
    }
    /**
     *  sets the geometry of the native element \
     *
     * @returns { void } sets the geometry of the native element.\
     * @param {string | SVGElement} value - provide the id value.
     *
     * @private
     */
    set content(value) {
        this.data = value;
        if (!this.canReset) {
            this.canReset = true;
            this.template = getContent(this, false);
            this.canReset = false;
            this.isDirt = true;
        }
    }
    /**
     *Measures minimum space that is required to render the Native Element \
     *
     * @returns { Size }Measures minimum space that is required to render the Native Element.\
     * @param {Size} availableSize - provide the id value.
     *
     * @private
     */
    measure(availableSize) {
        if (this.isDirt) {
            const rect = measureNativeContent(this.template);
            this.contentSize = new Size();
            this.contentSize.width = rect.width;
            this.contentSize.height = rect.height;
            const x = rect.x;
            const y = rect.y;
            this.templatePosition = { x, y };
            this.isDirt = false;
        }
        if (this.width === undefined || this.height === undefined) {
            const getAvailableSize = measureNativeSvg(this.template);
            this.desiredSize = new Size(getAvailableSize.width, getAvailableSize.height);
        }
        else {
            this.desiredSize = new Size(this.width, this.height);
        }
        this.desiredSize = this.validateDesiredSize(this.desiredSize, availableSize);
        return this.desiredSize;
    }
    /**
     *Arranges the Native Element \
     *
     * @returns { Size }Arranges the Native Element.\
     * @param {Size} desiredSize - provide the id value.
     *
     * @private
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    arrange(desiredSize) {
        this.actualSize = new Size(this.desiredSize.width, this.desiredSize.height);
        this.updateBounds();
        return this.actualSize;
    }
}
